import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';
import cogoToast from 'cogo-toast';

import {
  EDIT_PAUSE_DURATION_MODAL_STAGES,
  getUpdatedPauseDuration,
  resetUpdateDuration,
  setEditDurationModalStage,
  selectedRequestSelector,
  updateDurationTypeSelector,
  updateDurationSourceSelector,
  updateDurationMonthsBySelector,
  updatedMonthsDuration,
  useUpdateDurationMutation,
} from 'features/courseResume';
import GlobalLoader from 'components/GlobalLoader';
import styles from './UpdateDurationButton.module.scss';

function UpdateDurationButton() {
  const dispatch = useDispatch();
  const selectedRequest = useSelector(selectedRequestSelector);
  const durationType = useSelector(updateDurationTypeSelector);
  const durationSource = useSelector(updateDurationSourceSelector);
  const updateDurationMonthsBy = useSelector(updateDurationMonthsBySelector);
  const { duration_of_pause: durationOfPause } = selectedRequest;
  const updatedDuration = getUpdatedPauseDuration(
    durationOfPause,
    durationType,
    updateDurationMonthsBy?.value
  );
  const isUpdateAllowed = durationType && durationSource && updatedDuration > 0;
  const [updateDuration, { isSuccess, error, isLoading: isUpdating }] =
    useUpdateDurationMutation();

  const handleUpdateDuration = useCallback(() => {
    if (isUpdating) return;

    const updateDurationBy = updatedMonthsDuration(
      durationType,
      updateDurationMonthsBy?.value
    );

    updateDuration({
      requestId: selectedRequest.id,
      durationOfPause: updatedDuration,
      extensionDuration: updateDurationBy,
      extensionSource: durationSource,
    });
  }, [
    durationSource,
    durationType,
    isUpdating,
    selectedRequest.id,
    updateDuration,
    updateDurationMonthsBy,
    updatedDuration,
  ]);

  useEffect(() => {
    if (isSuccess) {
      batch(() => {
        dispatch(
          setEditDurationModalStage(EDIT_PAUSE_DURATION_MODAL_STAGES.success)
        );
        dispatch(resetUpdateDuration());
      });
      cogoToast.success('Successfully updated duration of request.');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in carrying out this action. Please try again later!'
      );
    }
  }, [error]);

  return (
    <div className={styles.root}>
      <GlobalLoader isVisible={isUpdating} />
      <Tappable
        onClick={handleUpdateDuration}
        disabled={isUpdating || !isUpdateAllowed}
        className={classNames('btn btn-primary', styles.button)}
      >
        Update Duration
      </Tappable>
    </div>
  );
}

export default UpdateDurationButton;
